import React from 'react';

const PaymentScreen = ({
  receiptTypes,
  isCounter,
  history,
  isWalkUp,
  handleCreditCard,
  showPoints,
  tipsMessage,
  paymentType,
  sourceType,
  setTextToPayModelOpen,
  currenySymbol,
  paymentAmount,
  preAuthFunctionCall,
  // keyboardValue,
  setPaymentType,
  unpaidAmount,
  totalAmount,
  tipAmount,
  handleRouteCheck,
  handleCheck,
  logo,
  makeGiftCardBalanceZero,
  handleButtonClick,
  tipsList,
  active,
  // handlePrint,
  paymentCallBack,
  handleReceiptPopUpOpen,
  handleRetry,
  PaymentPageBtn,
  handleSplitEvenly,
  handlePayAnAmount,
  isCash,
  handleKeyboardValue,
  validatePayAnAmount,
  // hideSignature,
  subTotalAmount,
  handleSurveySubmit,
  isGiftCard,
  isSecurityCode,
  handleGiftCard,
  giftCardPayment,
  giftBalance,
  setGiftBalance,
  paidAmount,
  giftCardSupportsSwipe,
  openCardPopUp,
  giftCardNumber,
  handleFailureRoute,
  isCreditCard,
  errorMessage,
  handleProcessCreditError,
  isDone,
  totalAmountForTip,
  charity,
  charityList,
  handleTipsRouteTo,
  applyDonation,
  handleGiftCancel,
  isQrScan,
  isKiosk,
  isTableTop,
  isServerApp,
  pointEarnings,
  successMessage,
  authResponse,
  tableData,
  deviceInfo,
  handleHideCancelIcon,
  handleChangePaymentType,
  userInfo,
  handleDirectToCashConfirmation,
  isExternalCreditCard,
  giftCardImages,
  setNotification,
  seat,
  setIsOpen,
  isOpen,
  giftCardMethods,
  creditRetryBtn,
  // ...props
}) => {

  const HandlePaymentScreenType = () => {
    switch (paymentType) {
      // case 1:
      //   return StartScreen();
      // case 2:
      //   return Fullcheck();
      // case 3:
      //   return (
      //     <PayProcess
      //       paymentCallBack={paymentCallBack}
      //       handleFailureRoute={handleFailureRoute}
      //       handleProcessCreditError={handleProcessCreditError}
      //       creditRetryBtn={creditRetryBtn}
      //     />
      //   );
      // case 4:
      //   return Tips();
      // case 5:
      //   return PaymentRecipt();
      // case 6:
      //   return PaymentConfirmationSuccess();
      // case 7:
      //   return PaymentConfirmationError();
      // case 8:
      //   return PaymentErrorRetry();
      // case 9:
      //   return <SplitEvenly />;
      // case 10:
      //   return <PayAnAmount />;
      // case 11:
      //   return <Survey handleSurveySubmit={handleSurveySubmit} />;
      // case 12:
      //   return (
      //     <GiftCard
      //       setGiftBalance={setGiftBalance}
      //       giftCardImages={giftCardImages}
      //       isSecurityCode={isSecurityCode}
      //       tableData={tableData}
      //       makeGiftCardBalanceZero={makeGiftCardBalanceZero}
      //       setPaymentType={setPaymentType}
      //       history={history}
      //       giftBalance={giftBalance.balanceAmount}
      //       paymentAmount={
      //         Number(totalAmount) - Number(paidAmount) + (!giftBalance?.suppressTip ? Number(tipAmount) : 0)
      //       }
      //       giftCardPayment={giftCardPayment}
      //       onSubmit={handleGiftCard}
      //       giftCardSupportsSwipe={giftCardSupportsSwipe}
      //       openCardPopUp={openCardPopUp}
      //       giftCardNumber={giftCardNumber}
      //       handleGiftCancel={handleGiftCancel}
      //       setNotification={setNotification}
      //       giftCardMethods={giftCardMethods}
      //     />
      //   );
      // case 13:
      //   return <Charity />;
      // case 14:
      //   return <QrPayFromPhone handleCheck={handleCheck} />;
      // case 15:
      //   return <IngenicoPayment />;
      // case 16:
      //   return (
      //     <CashReturn
      //       receiptTypes={receiptTypes}
      //       tableData={tableData}
      //       handleHideCancelIcon={handleHideCancelIcon}
      //       deviceInfo={deviceInfo}
      //       isCounter={isCounter}
      //       totalAmount={totalAmount}
      //       paymentType={paymentType}
      //       handleCheck={handleCheck}
      //       userInfo={userInfo}
      //       handleChangePaymentType={handleChangePaymentType}
      //     />
      //   );
      // case 17:
      //   return (
      //     <CashReturn
      //       receiptTypes={receiptTypes}
      //       handleHideCancelIcon={handleHideCancelIcon}
      //       deviceInfo={deviceInfo}
      //       isCounter={isCounter}
      //       totalAmount={totalAmount}
      //       paymentType={paymentType}
      //       handleCheck={handleCheck}
      //       userInfo={userInfo}
      //     />
      //   );
      // case 18:
      //   return (
      //     <CashReturn
      //       receiptTypes={receiptTypes}
      //       handleHideCancelIcon={handleHideCancelIcon}
      //       deviceInfo={deviceInfo}
      //       isCounter={isCounter}
      //       totalAmount={totalAmount}
      //       paymentType={paymentType}
      //       handleReceiptPopUpOpen={handleReceiptPopUpOpen}
      //       userInfo={userInfo}
      //       handleCheck={handleCheck}
      //     />
      //   );
      // case 19:
      //   return (
      //     <PaymentErrorRetryPreAuth />
      //   );
      // case 20:
      //   return PaymentCallCenterConfirmationSuccess();
      // case 21:
      //   return PaymentCallCenterConfirmationError();
      default:
        return <div />;
    }
  };

  return <>{HandlePaymentScreenType()}</>;
};

export default PaymentScreen;
